import axios from 'axios'
import { BACKEND_URL_STORE } from '@constants/server.constant'

export const createPreOrder = async (input: any) => {
  return await axios.post(`${BACKEND_URL_STORE}/pre-order`, input)
}
